module.exports = __webpack_public_path__ + "img/down-arrow.6141de18.svg";